/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type InvoiceApiResourceRecipientStatus = typeof InvoiceApiResourceRecipientStatus[keyof typeof InvoiceApiResourceRecipientStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceApiResourceRecipientStatus = {
  pending_payment: 'pending_payment',
  in_process: 'in_process',
  paid: 'paid',
  refunded: 'refunded',
  cancelled: 'cancelled',
  pending_balance: 'pending_balance',
  returned: 'returned',
  pending_group: 'pending_group',
  pending_reissue: 'pending_reissue',
} as const;
